import "./dnsLabel.scss";

const DnsLabel = () => {
  return (
    <div className="dns-label">DNS</div>
  );
};

export default DnsLabel;
